import type { NitroFetchOptions } from 'nitropack';

export function useSubmit() {
  const data = ref(null);
  const error = ref(null);
  const pending = ref(false);

  const execute = async (url: string, options: NitroFetchOptions<any> = {}) => {
    pending.value = true;
    error.value = null;
    
    try {
      const { $api } = useNuxtApp();
      const response = await $api(url, options);
      data.value = response;
    } catch (err: any) {
      error.value = err;
      throw err;
    } finally {
      pending.value = false;
    }
  };

  return {
    data: readonly(data),
    error: readonly(error),
    pending: readonly(pending),
    execute,
  };
}
